import {connect} from 'react-redux'

import {LunaAssist} from './lunaassist.component'
import userUtil from '../util/user.util'


const mapStateToProps = (state) => {
    return {
  	legs: state.getIn(['document', 'legs']),
  	tripName: state.getIn(['document', 'properties', 'tripTitle']),
  	currentUser: userUtil.getCurrentUser(state),
  	activeLeg: state.getIn(['uiState', 'activeLeg']),
  	detailSection: state.getIn(['uiState', 'detailSection']),
        detailSubSection: state.getIn(['uiState', 'detailSubSection']),
        detailSubDetail: state.getIn(['uiState', 'detailSubDetail']),
        activeAccommodation: state.getIn(['uiState', 'activeAccommodation']),
        activeAccommodationId: state.getIn(['uiState', 'activeAccommodationId']),
        activeActivityId: state.getIn(['uiState', 'activeActivityId']),
        activeActivity: state.getIn(['uiState', 'activeActivity']),
        activeTravel: state.getIn(['uiState', 'activeTravel']),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

const LunaAssistContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(LunaAssist)

export default LunaAssistContainer